<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar" /> 生产管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>工单列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-form ref="searchform" :model="searchform" label-width="90px" @keyup.enter.native="search()">
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="订单" prop="orderNo">
                                <el-input v-model="searchform.orderNo" type="text" clearable placeholder="请输入订单" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="产品编码" prop="product_code">
                                <el-select style="width:100%" v-model="searchform.product_code" clearable filterable
                                    remote placeholder="请输入产品名称或编码模糊匹配" :remote-method="getProductSelectList"
                                    :loading="productSelectLoading">
                                    <el-option v-for="item in productSelectList" :key="item.product_code"
                                        :label="item.product" :value="item.product_code" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="子工单" prop="subtask_order">
                                <el-input v-model="searchform.subtask_order" type="text" clearable
                                    placeholder="请输入子工单" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="计划生产日期" prop="plan_date" label-width="120px">
                                <el-date-picker v-model="searchform.plan_date" type="date" value-format="yyyy-MM-dd"
                                    format="yyyy 年 MM 月 dd 日" clearable placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="工单状态" prop="order_status">
                                <el-select v-model="searchform.order_status" type="text" clearable filterable
                                    style="width: 100%">
                                    <el-option v-for="(item, index) in statusList" :key="index" :label="item.label"
                                        :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" :offset="1">
                            <el-button v-permission="['orderSubtask_select']" type="primary" icon="el-icon-search"
                                @click="search()">搜索
                            </el-button>
                            <el-button @click="resetForm('searchform')">重置</el-button>
                            <el-button v-permission="['orderSubtask_select']" type="primary"
                                @click="settatle()">设置表列显示</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <br />
            <br />
            <el-row type="flex" class="row-bg">
                <el-col :span="24" class="border">
                    <h4>{{ $route.meta.title }}</h4>
                    <el-divider></el-divider>
                    <el-table border v-loading="tableLoading" element-loading-text="拼命加载中" :data="tableData"
                        style="width: 100%" id="parent">
                        <el-table-column type="expand">
                            <h3>原料列表</h3>
                            <template slot-scope="props">
                                <el-table :data="props.row.material_json" style="width: 100%">
                                    <el-table-column prop="material_code" label="原料编码" width="120" />
                                    <el-table-column prop="material_name" label="原料名称" width="250" />
                                    <el-table-column prop="material_quantity" label="原料计划数量" width="250" />
                                    <el-table-column prop="material_batchno" label="原料批次" width="120" />
                                </el-table>
                            </template>
                        </el-table-column>

                        <el-table-column v-for="item in tablerow" :key="item.key" :prop="item.key" :label="item.label"
                            :fixed="item.key == 'cz' ? 'right' : false" :min-width="item.width">
                        </el-table-column>
                        <el-table-column min-width="150" label="操作" fixed="right">
                            <template slot-scope="props">
                                <el-button type="primary" @click="getDetail(props.row)">
                                    修改</el-button>
                                <el-button v-permission="['orderSubtask_delete']" type="danger"
                                    @click="deletedate(props.row.id)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <br />
                    <el-pagination background layout="total,prev, pager, next, jumper, sizes" :total="pageTotal"
                        :page-sizes="[10, 20, 50, 100]" :page-size.sync="searchform.page_size"
                        :current-page.sync="searchform.page_index" @size-change="handleSizeChange"
                        @current-change="handleCurrentChange" />
                </el-col>
            </el-row>
            <TableHeader ref="TableHeader" :tablecolumn="tablecolumn" />
        </div>

        <el-dialog title="编辑加工单" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false">
            <el-form ref="resolveForm" :model="resolveForm" label-width="90px" :rules="rules">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="分解数量" prop="product_quantity">
                            <el-input @change="quantityInput" v-model.number="resolveForm.product_quantity"
                                style="width: 90%" clearable placeholder="请输入分解数量" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="计划生产日期" prop="plan_date" label-width="130px">
                            <el-date-picker style="width: 100%" v-model="resolveForm.plan_date" type="date"
                                value-format="yyyy-MM-dd" format="yyyy 年 MM 月 dd 日" clearable placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="备注" prop="remark">
                            <el-input v-model="resolveForm.remark" style="width: 90%" clearable placeholder="请输入备注" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-table :data="resolveForm.materials" stripe style="width: 100%" height="300">
                            <el-table-column prop="material_code" label="原料编码" min-width="150" show-overflow-tooltip />
                            <el-table-column prop="material_name" label="原料名称" min-width="150" show-overflow-tooltip />
                            <el-table-column prop="material_ratio" label="比例" show-overflow-tooltip min-width="80" />
                            <el-table-column prop="material_quantity" label="原料计划数量" min-width="150">
                                <template slot-scope="scope">
                                    <el-input v-model.number="scope.row.material_quantity" style="width: 70%"
                                        placeholder="请输入原料计划数量" />
                                </template>
                            </el-table-column>
                            <el-table-column prop="material_batchno" label="原料批次" min-width="150">
                                <template slot-scope="scope">
                                    <el-input v-model.number="scope.row.material_batchno" style="width: 70%"
                                        placeholder="请输入原料批次" />
                                </template>
                            </el-table-column>
                            <el-table-column prop="address" label="操作" width="160px" fixed="right">
                                <template slot-scope="scope">
                                    <el-button type="primary" @click.native.prevent="
                                        addRow(scope.$index, resolveForm.materials)
                                        ">增加</el-button>
                                    <el-button v-if="scope.row.type !== 1" type="danger" @click.native.prevent="
                                        deleteRow(scope.$index, resolveForm.materials)
                                        ">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitadd('resolveForm')">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import {
    workorderprocessingsubtaskList,
    workorderprocessingsubtaskUpdate,
    workSubtaskDelete,
    downloadbackwork,
} from "@/api/plant";
import { productlist } from "@/api/base";
import TableHeader from "@/components/HeaderSearch/TableHeader";
import OrderAdd from "./components/orderPlus/OrderAdd";
export default {
    name: "orderSubtask",
    components: { OrderAdd, TableHeader },
    data() {
        return {
            dialogVisible: false,
            resolveForm: {
                materials: [],
            },
            rules: {
                product_quantity: [
                    { required: true, message: "请输入分解数量", trigger: "blur", type: "number" },
                ],
                plan_date: [
                    { required: true, message: "请选择计划生产日期", trigger: "blur" },
                ],
                remark: [
                    { required: true, message: "请输入备注", trigger: "blur" },
                ],
            },
            // 表格数据
            tableLoading: false,
            tableData: [],
            tablerow: [],
            tablecolumn: [
                {
                    label: "生产订单号",
                    key: "orderno",
                    width: "150",
                },
                {
                    label: "产品编码",
                    key: "product_code",
                    width: "120",
                },
                {
                    label: "产品名称",
                    key: "product_name",
                    width: "170",
                },
                {
                    label: "生产日期",
                    key: "plan_date",
                    width: "120",
                },
                {
                    label: "计划生产数量",
                    key: "product_quantity",
                    width: "100",
                },
                {
                    label: "子工单",
                    key: "subtask_order",
                    width: "160",
                },
                {
                    label: "1级采集数量",
                    key: "package_level1_count",
                    width: "90",
                },
                {
                    label: "1级生产数量",
                    key: "package_level1_produce",
                    width: "90",
                },
                {
                    label: "1级采集率",
                    key: "harvest_rate1",
                    width: "90",
                },
                {
                    label: "2级采集数量",
                    key: "package_level2_count",
                    width: "90",
                },
                {
                    label: "2级生产数量",
                    key: "package_level2_produce",
                    width: "90",
                },
                {
                    label: "2级采集率",
                    key: "harvest_rate2",
                    width: "90",
                },
                {
                    label: "3级采集数量",
                    key: "package_level3_count",
                    width: "90",
                },
                {
                    label: "3级生产数量",
                    key: "package_level3_produce",
                    width: "90",
                },
                {
                    label: "3级采集率",
                    key: "harvest_rate3",
                    width: "90",
                },
                {
                    label: "计划开始时间",
                    key: "produce_time",
                    width: "140",
                },
                {
                    label: "计划结束时间",
                    key: "complete_time",
                    width: "140",
                },
                {
                    label: "生产状态",
                    key: "statusname",
                    width: "80",
                },
                {
                    label: "备注",
                    key: "remark",
                    width: "120",
                },
            ],
            // 产品下拉选择列表
            productSelectLoading: false,
            productSelectList: [],
            //分页数据
            pageTotal: 0,
            //搜索表单数据
            searchform: {
                orderNo: null,
                product_code: null,
                subtask_order: null,
                plan_date: null,
                order_status: null,
                page_size: 10,
                page_index: 1,
            },
            statusList: [
                { label: '全部', value: -1 },
                { label: '未下载', value: 0 },
                { label: '已下载', value: 1 },
                { label: '开始生产', value: 2 },
                { label: '开始上传', value: 3 },
                { label: '结束生产', value: 4 },
            ],
        };
    },
    mounted() {
        this.getProductSelectList();
        this.search();
    },
    methods: {
        settatle() {
            // 设置表头
            this.$refs.TableHeader.drawer = true;
        },
        getrowshow() {
            this.tablerow = this.$refs.TableHeader.tablerow;
            this.$refs.TableHeader.drawer = false;
        },
        // 获取产品下拉列表
        getProductSelectList(value) {
            if (value !== "") {
                this.productSelectLoading = true;
                setTimeout(() => {
                    this.productSelectLoading = false;
                    productlist({ productName: value }).then(response => {
                        this.productSelectList = response.data.data || [];
                        for (var item of this.productSelectList) {
                            item.product = item.product_code + " - " + item.product_name;
                        }
                    });
                }, 200);
            } else {
                this.productSelectList = [];
            }
        },
        //请求表格数据
        fetchTableData() {
            this.tableLoading = true;
            workorderprocessingsubtaskList(this.searchform).then((response) => {
                this.tableData = response.data.data;
                this.packdate(this.tableData);
                this.pageTotal = response.data.total_count;
            }).finally(() => {
                this.tableLoading = false;
            });
        },
        packdate(data) {
            data.forEach(item => {
                item.material_json = JSON.parse(item.material_json);
                item.statusname = this.statusList.filter(el => el.value === item.order_status)[0].label,
                    item.harvest_rate1 = item.package_level1_produce == 0 ? '0%' : (item.package_level1_count / item.package_level1_produce * 100).toFixed(2) + "%";
                item.harvest_rate2 = item.package_level2_produce == 0 ? '0%' : (item.package_level2_count / item.package_level2_produce * 100).toFixed(2) + "%";
                item.harvest_rate3 = item.package_level3_produce == 0 ? '0%' : (item.package_level3_count / item.package_level3_produce * 100).toFixed(2) + "%";
                item.plan_date = item.plan_date ? this.$parseTime(item.plan_date).slice(0, 10) : '';
                item.produce_time = item.produce_time ? this.$parseTime(item.produce_time) : '';
                item.complete_time = item.complete_time ? this.$parseTime(item.complete_time) : '';
            });
        },
        //重置按钮
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.tableData = [];
            this.pageTotal = 0;
            this.searchform.page_index = 1;
            this.searchform.page_size = 10;
            this.getProductSelectList();
            this.search();
        },
        //搜索事件
        search() {
            this.searchform.page_index = 1;
            this.fetchTableData();
        },
        //分页跳转事件
        handleCurrentChange(val) {
            this.fetchTableData();
        },
        //分页每页显示条数事件
        handleSizeChange(val) {
            this.fetchTableData();
        },
        // 删除按钮事件
        deletedate(id) {
            this.$confirm("此操作将永久删除该工单信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    workSubtaskDelete({ id }).then((response) => {
                        if (response.status_code == 200) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            this.search();
                        } else {
                            this.$message({
                                type: "woring",
                                message: "删除失败!请检查字段",
                            });
                        }
                    });
                })
        },
        getDetail(data) {
            this.resolveForm = data
            this.resolveForm.materials = structuredClone(data.material_json)

            this.$forceUpdate()
            this.dialogVisible = true
        },
        // 表格行删除
        deleteRow(index, rows) {
            rows.splice(index, 1);
        },
        addRow(index, rows) {
            const obj = [rows[index]].map(item => {
                return {
                    material_code: item.material_code,
                    material_name: item.material_name,
                    material_ratio: item.material_ratio,
                    material_quantity: 0,
                    material_batchno: 0,
                    type: 0,
                }
            })[0]
            rows.splice(index + 1, 0, obj)
        },
        // 保存提交
        submitadd(formName) {
            this.$refs[formName].validate((valid) => {
                // 基础表单验证
                if (valid) {
                    if (this.resolveForm.materials.length == 0) {
                        this.$message({
                            type: "warning",
                            message: "请添加产品",
                        });
                        return
                    }
                    workorderprocessingsubtaskUpdate(this.resolveForm).then((response) => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                        this.resolveForm.materials = [];
                        this.resetForm(formName);
                        this.dialogVisible = false
                    });
                }
            });
        },
        quantityInput(val) {
            this.resolveForm.materials.forEach(item => {
                item.material_quantity = item.material_ratio * val
            })
            this.$forceUpdate()
        },
    },
};
</script>
<style scoped>
.rightclass {
    z-index: 9999;
}

.bottstycz {
    display: block !important;
    width: 150px;
    margin: 5px;
}
</style>